<template>
    <div class="row">
       
        <div class="col-lg-4 checkout-content" style="min-height: 250px; padding-left: 0px; padding-right: 0px;" v-bind:style="{'background-image': 'url(' + Store.Checkout.BackgroundImage + ')'}">
            <div class="d-flex justify-content-center shadow" style="background-color: white; opacity:0.5">
                <div class="p-3">
                    Choose the DAY you want for your<br /><span class="fw-bold" style="color:limegreen">Mobile Notarization</span>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3 mb-3">
                <div id="daypicker" class="daypicker shadow"/>
            </div>
        </div>

        <div class="col-lg-8 p-0" v-if="Store.Checkout.SelectedDayAppointments">
           
            <div class="d-flex justify-content-center shadow" style="background-color: white; opacity:0.5">
                <div class="p-3" v-if="Store.Checkout.SelectedDayAppointments.length">
                    Choose your meeting TIME on<br /><span class="fw-bold" style="color:limegreen">{{SelectedDayLongText}}</span>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-3 mb-3" v-if="Store.Checkout.SelectedDayAppointments.length">
                <!-- Create a table with 2 columns, fitting 2 appointments, i.e. apt objects in each row-->
                <table>
                    <tr v-for="(group, index) in Store.GroupedAppointments" :key="index">
                        <td v-for="appointment in group" :key="appointment.startTime">
                            <input v-model="Store.Checkout.Cart.ChosenAppointmentSlot" :value="appointment" type="radio" class="btn-check" name="btnradio" :id="'option' + appointment.startTime" autocomplete="off">
                            <label class="btn btn-outline-primary" :for="'option' + appointment.startTime">
                                {{ Store.FormatTime(appointment.startTime) }}<br>
                                <small>({{appointment.duration}} mins allot.)</small>
                            </label>
                        </td>
                    </tr>
              
                </table>
            </div>
        </div>
    </div>

</template>

<script>

    import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'SchedulerFieldNotary',
        components: {
        },
        props: {
        },
        
        data() {
            return {
                Store: {}
            };
        },        
        methods:
        {
            OnCmdNext: async function () {
                if (this.Store.Checkout.Cart.CurrentStep != 2 || this.Store.Checkout.Cart.SelectedService != "FieldNotarization") {
                    
                    return;
                }

               
                this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)
            },
            OnStepActivated: async function () {
                if (this.Store.Checkout.Cart.CurrentStep == 2 && this.Store.Checkout.Cart.SelectedService == "FieldNotarization"){
                    this.Store.Checkout.NextButton.IsVisible = false;
                    this.Store.LoadSchedule();
                }
            }
        },
        watch:{
            'Store.Checkout.Cart.ChosenAppointmentSlot': function(newVal, oldVal){
                
                if(this.Store.Checkout.Cart.CurrentStep != 2){
                    return;
                }
                
                if(newVal != null){
                      this.Store.Checkout.NextButton.Text = "Continue To Payment";
                      this.Store.Checkout.NextButton.Icon = "bi-cart-check";
                      this.Store.Checkout.NextButton.IsVisible = true;
                }
                else{
                    this.Store.Checkout.NextButton.IsVisible = false;
                }
            }
        },
        computed:
        {
            SelectedDayLongText: function () {
                if (!this.Store.Checkout.Cart.SelectedDate) {
                    return "";
                }
                const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                var date = this.Store.Checkout.Cart.SelectedDate;

                // Get day, month, date, and year
                const day = days[date.getDay()];
                const month = months[date.getMonth()];
                const dayOfMonth = date.getDate();
                const year = date.getFullYear();

                // Get the ordinal suffix
                const ordinal = ((dayOfMonth) => {
                    const j = dayOfMonth % 10,
                        k = dayOfMonth % 100;
                    if (j == 1 && k != 11) {
                        return "st";
                    }
                    if (j == 2 && k != 12) {
                        return "nd";
                    }
                    if (j == 3 && k != 13) {
                        return "rd";
                    }
                    return "th";
                })(dayOfMonth);

                // Format the date
                return `${day} ${month} ${dayOfMonth}${ordinal}, ${year}`;
            },
        },
        beforeMount: function () {           
        },
        created() {
            this.Store = useEditorStore();
            EventHub.$on('OnCmdNext', this.OnCmdNext);
            EventHub.$on('OnStepActivated', this.OnStepActivated);
            
        },
        beforeUnmount() {
            EventHub.$off('OnStepActivated', this.OnStepActivated);
            EventHub.$off('OnCmdNext', this.OnCmdNext);
        },
    }
</script>

<style>
  
</style>